export const DEFAULT_NODE_POSITION = { x: 0, y: 0 };
